import { useEffect, useRef } from "react";

export const useResetOnModelUpdate = <T>(
  model: T,
  reset: (model: T) => void
) => {
  const ref = useRef<T | null | undefined>();
  // This hook prevents `reset` running the very first time the form is seeing the model.
  //  The initial loading of the form should be done by passing `defaultValues` to `useForm`
  //  and so having `reset` run just after that initialisation is redundant.
  useEffect(() => {
    if (ref.current && ref.current !== model) {
      reset(model);
    }
    ref.current = model;
  }, [reset, model]);
};
